<template lang="pug">
  .d-flex.align-center.py-4
    search(
      v-model="model.filters.search"
      placeholder="Search by text query"
      @change="setQuery"
    ).search.pr-3

    v-select(
      item-value="value"
      item-text="title"
      v-model="model.filters.is_active"
      solo
      dense
      flat
      menu-props="offset-y"
      :items="model.options.statuses.list"
      :loading="model.options.statuses.loading"
      :disabled="model.options.statuses.loading"
      @change="setQuery"
      label="Status"
    ).filter.mr-3

    .filter--date.mr-3
      date-picker(
        label="Expires date"
        v-model="model.filters.expires_in"
        @change="setQuery"
        @update:picker-date="setQuery"
        range
      )
    .filter--date.mr-3
      date-picker(
        label="Deactivated date"
        v-model="model.filters.deactivated_at"
        @change="setQuery"
        range
      )
    .filter--date
      date-picker(
        label="Paid date"
        v-model="model.filters.paid_at"
        @change="setQuery"
        range
      )
</template>

<script>
import {OrdersFiltersModel} from "../core/models/OrdersFiltersModel";
import {FILTERS_ARGS} from "@/app/exercise/modules/payments/core/models/OrdersConst";

export default {
  components: {
    search: () => import("@/components/global/Search.vue"),
    datePicker: () => import("@/components/global/DateTimePickerMenu.vue")
  },
  data: () => ({
    model: {},
  }),
  created() {
    this.initFilters();
  },
  methods: {
    initFilters() {
      this.model = new OrdersFiltersModel(this.$route.query);
    },

    async setQuery() {
      const query = this. _transformQueryParams({ ...this.$route.query, ...this.model.getApiData() });
      await this.$router.replace({query})
      this.$emit('filterChanged')
    },
    
    _transformQueryParams(query) {
      let ordering = query.ordering || [];
      const orderingFields = {
        expires_in: 'expires_in',
        paid_at: 'paid_at',
        deactivated_at: 'deactivated_at'
      };
      const orderingKeys = {
        [orderingFields.expires_in]: [FILTERS_ARGS.EXPIRES_IN_FROM, FILTERS_ARGS.EXPIRES_IN_TO],
        [orderingFields.paid_at]: [FILTERS_ARGS.PAID_AT_FROM, FILTERS_ARGS.PAID_AT_TO],
        [orderingFields.deactivated_at]: [FILTERS_ARGS.DEACTIVATED_AT_FROM, FILTERS_ARGS.DEACTIVATED_AT_TO],
      };

      Object.keys(orderingKeys).forEach( orderingKey => {
        if( query[orderingKeys[orderingKey][0]] ||  query[orderingKeys[orderingKey][1]] ) {
          ordering = ordering.filter( item => !item.includes(orderingKey));
          ordering.push('-' + orderingKey);
        }
      } );
      return {...query, ordering};
    }
  }
}
</script>

<style lang="scss" scoped>
  .search {
    width: 280px;
    &::v-deep {
      .v-input__slot{
        &:before {
          display: none;
        }
      }
    }
  }
  .filter {
    flex: 0 1 200px;
    max-width: 200px;

    &--date {
      flex: 0 1 240px;
      max-width: 240px;
    }
  }
  .v-input::v-deep {
    .v-input__slot {
      margin: 0;
    }
    .v-input__control {
      min-height: auto!important;
    }
    .v-text-field__details {
      display: none;
    }
  }
</style>
